import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import { AvoidSoftInput } from 'react-native-avoid-softinput'

export function useAvoidSoftInputForScreen() {
    useFocusEffect(
        useCallback(() => {
            AvoidSoftInput.setEnabled(true)

            return () => AvoidSoftInput.setEnabled(false)
        }, [])
    )
}
